import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20film%20studio%20set%20with%20warm%20dramatic%20lighting%2C%20vintage%20movie%20camera%20in%20foreground%2C%20dark%20theater%20curtains%2C%20film%20reels%2C%20atmospheric%20smoke%2C%20gold%20and%20crimson%20accents%2C%20professional%20cinematic%20photography%2C%20rich%20contrast%2C%20epic%20mood&width=1920&height=960&seq=hero-bg-01&orientation=landscape"
        alt="91制片厂 - 原创影视内容平台"
        title="91制片厂 - 优质影视内容创作与发行平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-500/20 border border-primary-500/30 rounded-full mb-6 animate-fade-in">
            <i className="ri-sparkling-line text-primary-400 text-sm"></i>
            <span className="text-primary-300 text-xs md:text-sm font-medium">2024年度最佳原创内容平台</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-5">
            用心创作
            <span className="text-primary-400">每一帧</span>
            <br />
            让故事<span className="text-accent-400">发光</span>
          </h1>
          <p className="text-foreground-300 text-sm md:text-lg leading-relaxed max-w-xl mx-auto mb-8">
            91制片厂汇聚海量原创影视作品，涵盖动作、剧情、纪录、喜剧等多元类型，
            以4K超高清画质，为你呈现每一部精心打磨的原创内容。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/dongzuo"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观影
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/10 hover:bg-background-50/20 border border-foreground-50/20 text-foreground-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">2,000+</div>
              <div className="text-xs text-foreground-400 mt-1">原创作品</div>
            </div>
            <div className="w-px h-10 bg-foreground-50/10"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">5,000万+</div>
              <div className="text-xs text-foreground-400 mt-1">注册用户</div>
            </div>
            <div className="w-px h-10 bg-foreground-50/10"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">9.2</div>
              <div className="text-xs text-foreground-400 mt-1">用户评分</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}